import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useCartStore, useUIStore, useUserStore } from '../../store';

const HomeIcon: React.FC<{ active: boolean }> = ({ active }) => (
  <svg width="24" height="26" viewBox="0 0 24 26" fill="none">
    <path
      d="M12.8093 2.41424L20.6307 8.83691C21.0707 9.19691 21.3333 9.75157 21.3333 10.3436V22.0809C21.3333 23.1662 20.4827 24.0009 19.4893 24.0009H16V17.6676C16 16.6951 15.6137 15.7625 14.9261 15.0749C14.2384 14.3872 13.3058 14.0009 12.3333 14.0009H11C10.0276 14.0009 9.09492 14.3872 8.40729 15.0749C7.71966 15.7625 7.33335 16.6951 7.33335 17.6676V24.0009H3.84401C2.85068 24.0009 2.00001 23.1662 2.00001 22.0809V10.3449C2.00001 9.75158 2.26268 9.19824 2.70268 8.83824L10.524 2.41291C10.8449 2.14592 11.2492 1.99974 11.6667 1.99974C12.0841 1.99974 12.4884 2.14725 12.8093 2.41424ZM19.4893 25.9996C21.636 25.9996 23.3333 24.2196 23.3333 22.0796V10.3436C23.3349 9.76035 23.2071 9.18402 22.9593 8.65607C22.7115 8.12812 22.3497 7.66166 21.9 7.29024L14.08 0.867574C13.4013 0.306779 12.5484 0 11.668 0C10.7876 0 9.93471 0.306779 9.25601 0.867574L1.43335 7.29157C0.983668 7.66299 0.621898 8.12945 0.374059 8.6574C0.126221 9.18536 -0.00152417 9.76168 1.37224e-05 10.3449V22.0809C1.37224e-05 24.2209 1.69735 26.0009 3.84401 26.0009L19.4893 25.9996Z"
      fill={active ? '#3657F0' : '#BBBEC0'}
    />
  </svg>
);

const HeartIcon: React.FC<{ active: boolean }> = ({ active }) => (
  <svg width="24" height="22" viewBox="0 0 24 22" fill="none">
    <path
      d="M12 22L10.26 20.4174C4.08 14.8185 0 11.1139 0 6.59401C0 2.88937 2.904 0 6.6 0C8.688 0 10.692 0.971117 12 2.49373C13.308 0.971117 15.312 0 17.4 0C21.096 0 24 2.88937 24 6.59401C24 11.1139 19.92 14.8185 13.74 20.4174L12 22Z"
      fill={active ? '#3657F0' : '#BBBEC0'}
    />
  </svg>
);

const CartIcon: React.FC<{ active: boolean }> = ({ active }) => (
  <svg width="24" height="25" viewBox="0 0 24 25" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.23604 1.33333C7.60843 0.546667 8.41173 0 9.34005 0H14.6599C15.5883 0 16.3902 0.546667 16.764 1.33333C17.6723 1.34133 18.3812 1.38267 19.0143 1.63067C19.77 1.92703 20.4273 2.43068 20.9108 3.084C21.3989 3.74267 21.629 4.58667 21.9429 5.748L22.9297 9.37733L23.3021 10.4987L23.334 10.5387C24.5323 12.0773 23.9618 14.3653 22.8207 18.94C22.0945 21.8507 21.7327 23.3053 20.6501 24.1533C19.5675 25 18.0713 25 15.0789 25H8.92111C5.92867 25 4.43245 25 3.34985 24.1533C2.26726 23.3053 1.90417 21.8507 1.17934 18.94C0.0382206 14.3653 -0.532338 12.0773 0.665968 10.5387L0.697887 10.4987L1.07028 9.37733L2.05712 5.748C2.37232 4.58667 2.60241 3.74133 3.08918 3.08267C3.57293 2.42984 4.23016 1.92666 4.98572 1.63067C5.61879 1.38267 6.32633 1.34 7.23604 1.33333ZM7.2387 3.33733C6.35825 3.34667 6.00448 3.38 5.71189 3.49467C5.30487 3.65424 4.95089 3.92548 4.69047 4.27733C4.45639 4.59333 4.31807 5.03467 3.93238 6.45733L3.1743 9.24267C4.53087 9 6.38485 9 8.91978 9H15.0789C17.6151 9 19.4678 9 20.8244 9.24L20.0676 6.45467C19.6819 5.032 19.5436 4.59067 19.3095 4.27467C19.0491 3.92281 18.6951 3.65157 18.2881 3.492C17.9955 3.37733 17.6417 3.344 16.7613 3.33467C16.5725 3.73313 16.2748 4.06976 15.9029 4.30552C15.531 4.54128 15.1 4.6665 14.6599 4.66667H9.34005C8.90016 4.66662 8.46928 4.54159 8.09737 4.30608C7.72545 4.07057 7.42773 3.73555 7.2387 3.33733Z"
      fill={active ? '#3657F0' : '#BBBEC0'}
    />
  </svg>
);

const ProfileIcon: React.FC<{ active: boolean }> = ({ active }) => (
  <svg width="22" height="25" viewBox="0 0 22 25" fill="none">
    <path
      d="M11 12.5C14.4719 12.5 17.2857 9.70215 17.2857 6.25C17.2857 2.79785 14.4719 0 11 0C7.52812 0 4.71429 2.79785 4.71429 6.25C4.71429 9.70215 7.52812 12.5 11 12.5ZM15.4 14.0625H14.5799C13.4897 14.5605 12.2768 14.8438 11 14.8438C9.72321 14.8438 8.51518 14.5605 7.42009 14.0625H6.6C2.95625 14.0625 0 17.002 0 20.625V22.6562C0 23.9502 1.0558 25 2.35714 25H19.6429C20.9442 25 22 23.9502 22 22.6562V20.625C22 17.002 19.0437 14.0625 15.4 14.0625Z"
      fill={active ? '#3657F0' : '#BBBEC0'}
    />
  </svg>
);

export const BottomNavigation: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const activeRegion = useUserStore((s) => s.lastSelectedRegion);
  const cartCount = useCartStore((s) =>
    activeRegion
      ? (s.itemsByRegion[activeRegion] || []).reduce((sum, item) => sum + item.quantity, 0)
      : 0
  );
  const isSearchActive = useUIStore((s) => s.isSearchActive);
  const isKeyboardOpen = useUIStore((s) => s.isKeyboardOpen);

  const isMobile = typeof window !== 'undefined' && /Mobi|Android|iPhone|iPad/i.test(navigator.userAgent);
  const shouldHide = isSearchActive || (isKeyboardOpen && isMobile);

  // «Главная» ведет на первый экран (выбор PS Store / шеринг); подсвечена на нем и на главных страницах разделов
  const navItems = [
    { label: 'Главная', path: '/main', activeOn: ['/main', '/home', '/sharing'], icon: (a: boolean) => <HomeIcon active={a} /> },
    { label: 'Избранное', path: '/favorites', icon: (a: boolean) => <HeartIcon active={a} /> },
    { label: 'Корзина', path: '/cart', badge: cartCount, icon: (a: boolean) => <CartIcon active={a} /> },
    { label: 'Профиль', path: '/profile', icon: (a: boolean) => <ProfileIcon active={a} /> },
  ];

  return (
    <nav
      className={`fixed left-0 right-0 bg-white border-t z-40 transition-all duration-300 ease-in-out ${
        shouldHide ? 'translate-y-full opacity-0 pointer-events-none' : 'translate-y-0 opacity-100'
      }`}
      style={{ bottom: 0, borderColor: '#E1E3E5', paddingBottom: 'env(safe-area-inset-bottom, 0px)' }}
    >
      <div className="flex items-center justify-around" style={{ padding: '4px 16px 0 16px', height: '62px' }}>
        {navItems.map((item) => {
          const isActive = (item.activeOn || [item.path]).includes(location.pathname);
          return (
            <button
              key={item.path}
              onClick={() => navigate(item.path)}
              className="flex flex-col items-center justify-center min-w-[56px] relative"
              style={{ padding: '6px 16px' }}
            >
              <div className="relative flex items-end justify-center" style={{ height: '26px' }}>
                {item.icon(isActive)}
                {item.badge != null && item.badge > 0 && (
                  <span
                    className="absolute z-10 text-white font-bold rounded-full flex items-center justify-center"
                    style={{ background: '#3657F0', top: '-5px', right: '-24px', width: '20px', height: '20px', fontSize: '11px' }}
                  >
                    {item.badge > 99 ? '99+' : item.badge}
                  </span>
                )}
              </div>
              <span
                className="mt-0.5 transition-colors"
                style={{
                  fontFamily: 'Manrope, sans-serif',
                  fontSize: '13px',
                  fontWeight: isActive ? 700 : 500,
                  color: isActive ? '#3657F0' : '#BBBEC0',
                }}
              >
                {item.label}
              </span>
            </button>
          );
        })}
      </div>
    </nav>
  );
};
